import React, { useEffect } from 'react';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { parseDecimal } from '../../../../common/logics';
import { thousandSeparator } from '../../../BusinessDetails/utils/utils';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

export type ValueType = 'percent' | 'amount';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    unit: {
      display: 'flex',
      flexDirection: 'column',
    },
    beneficiary: {
      padding: theme.spacing(0, 1),
    },
  }),
);

const CustomValue: React.FC<{
  amount: number;
  beneficiaryName: string;
  onTypeAmountSelected: (type: ValueType) => void;
  amountDisplayinType: ValueType;
}> = (props) => {
  const { amount, beneficiaryName } = props;
  const classes = useStyles();

  const [selected, setSelected] = React.useState<ValueType>('percent');

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (selected: ValueType) => {
    setAnchorEl(null);
    props?.onTypeAmountSelected(selected);
  };

  useEffect(() => {
    setSelected(props?.amountDisplayinType);
  }, [props.amountDisplayinType]);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Typography>
        {selected === 'percent'
          ? parseDecimal(amount?.toString()).toFixed(2)
          : thousandSeparator(amount?.toString())}
      </Typography>
      &nbsp;
      <Typography aria-describedby={id} onClick={handleClick}>
        {selected === 'percent' ? `%` : `€`}
      </Typography>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        <Box className={classes.unit}>
          <Button onClick={() => handleSelect('percent')}>Pourcentage</Button>
          <Button onClick={() => handleSelect('amount')}>Montant</Button>
        </Box>
      </Popover>
      <Typography className={classes.beneficiary}>{beneficiaryName}</Typography>
    </>
  );
};

export default CustomValue;
